
























































































































import Vue from "vue";
import moment from "moment";

import permission, { PermissionName } from "@/common/mixins/permission";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import { OrderBridgeSystem, TrackingNumber } from "../models/OrderBridgeSystem";
import { ApprovalStatus } from "../models/ApprovalStatus";
import BridgeSystemDatePickers from "../components/BridgeSystemDatePickers.vue";
import { Shop } from "@/features/shop/models/Shop";

export default Vue.extend({
  components: { BridgeSystemDatePickers },
  mixins: [pagination, permission, dialog],
  data() {
    const approvalAmount = 1;
    const waitingOrders: OrderBridgeSystem[] = [];
    const searchText = "";
    const shopId = 0;
    const shopInfo: Shop[] = [];
    const fromDate = moment()
      .add(-30, "days")
      .format("YYYY-MM-DD");
    const toDate = moment(new Date()).format("YYYY-MM-DD");
    const maxDate = moment(new Date()).format("YYYY-MM-DD");
    return {
      waitingOrders,
      approvalAmount,
      approvalAmountRule: [
        (v: number) => v > -1 || "กรุณากรอกอย่างน้อย 1 ออเดอร์",
        (v: number) => v < 1501 || "อนุมัติออเดอร์ได้มากสุดที่ 1500 ออเดอร์"
      ],
      searchText,
      shopId,
      shopInfo,
      fromDate,
      toDate,
      maxDate
    };
  },
  computed: {
    hasPromotionCreatePermission() {
      return (this as any).hasPermission(PermissionName.API_BRIDGE_ACTION);
    }
  },
  async created() {
    (this as any).getPaginationRouteQuery();
    await Promise.all([this.getWaitingOrders(), this.getShop()]);
  },
  watch: {
    async "$route.query"() {
      await this.getWaitingOrders();
      await this.getShop();
    }
  },
  methods: {
    async getWaitingOrders() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };

      const fromDate = moment(this.fromDate)
        .startOf("days")
        .format();
      const toDate = moment(this.toDate)
        .endOf("days")
        .format();

      try {
        const {
          data,
          meta
        } = await (this as any).$dep.bridgeSystemUseCase.getOrders(
          form,
          ApprovalStatus.WAITING,
          fromDate,
          toDate,
          this.searchText,
          this.shopId
        );
        this.waitingOrders = data;
        (this as any).setPaginationMeta(meta);
        (this as any).setSearchQuery(this.searchText);
      } catch (error) {
        console.log(error);
      }
    },
    async getShop() {
      try {
        const { data } = await (this as any).$dep.bridgeSystemUseCase.getShop();
        this.shopInfo = data;
      } catch (error) {
        console.log(error);
      }
    },
    gotoBridgeSystemViewPage() {
      this.$router.push({ name: "BridgeSystemViewPage" });
      location.reload();
    },

    async approveOrder() {
      try {
        await (this as any).$dep.bridgeSystemUseCase.postApproveOrder(
          this.approvalAmount
        );

        if (
          await (this as any).alertSuccess(
            "Success",
            "อนุมัติรายการสั่งซื้อสำเร็จ"
          )
        ) {
          this.gotoBridgeSystemViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        }
      }
    },
    async searchOrders() {
      (this as any).setPaginationMeta({
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 10
      });
      this.getWaitingOrders();
    },
    async getByShop() {
      this.getWaitingOrders();
    },
    setFromDate(date: string, notFetch = false) {
      this.fromDate = date;
      if (!notFetch) {
        this.getWaitingOrders();
      }
    },
    setToDate(date: string, notFetch = false) {
      this.toDate = date;
      if (!notFetch) {
        this.getWaitingOrders();
      }
    },
    disabledButton() {
      return this.waitingOrders.length === 0;
    },
    mapTrackingNumber(value: TrackingNumber[]) {
      const trackingNumbers = value.map(item => item.trackingNumber);
      return trackingNumbers.join(",");
    },
    async submit() {
      if (this.waitingOrders.length === 0) {
        await (this as any).alertError(
          "No order",
          `ไม่มีรายการการสั่งซื้อสินค้า`
        );
      } else if (this.approvalAmount > 0 && this.approvalAmount <= 1500) {
        const isConfirmed = await (this as any).alertConfirm(
          "Confirm to approve order",
          `คุณต้องการอนุมัติรายการสั่งซื้อจำนวน ${this.approvalAmount} หรือไม่ ?`
        );
        if (isConfirmed) {
          await this.approveOrder();
        }
      } else if (this.approvalAmount > 1500) {
        await (this as any).alertError(
          "Approve order",
          `จำนวนรายการสั่งซื้ออนุมัติได้มากสุด 1500 รายการ`
        );
      } else {
        await (this as any).alertError(
          "Approve order",
          `กรุณากรอกจำนวนรายการสั่งซื้อที่ต้องการอนุมัติอย่างน้อย 1 รายการ`
        );
      }
    }
  }
});
